

export default {
  name: 'Logo',
  props: {
    logo: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    linkTo() {
      return this.$route.path === '/' ? null : '/';
    },
  },
}
